import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";

export default function StaticPage() {
  const { key } = useParams();
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {}); }, [key]);
  const page = (settings?.pages || []).find((p) => p.key === key);
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-6 py-14">
        <h1 className="font-display text-3xl font-bold tracking-tight lg:text-4xl" data-testid="static-title">{page?.name || "Information"}</h1>
        <div className="prose mt-6 max-w-none text-muted-foreground">
          {page?.visible === false ? (
            <p>This page is currently unavailable.</p>
          ) : (
            <p className="whitespace-pre-line leading-relaxed" data-testid="static-content">{page?.content || "Content coming soon."}</p>
          )}
        </div>
      </div>
    </PublicLayout>
  );
}
